import debug from "debug";

import { newrelic } from "@jti/fe-clients";

class ErrorClient {
  private readonly logger;
  private errorLogger;

  constructor() {
    this.logger = debug("product-details");
    this.errorLogger = debug("product-details:error");
  }

  reportError(message: string): void {
    this.errorLogger(message);

    console.error(message);
    newrelic.noticeError(new Error(message));
  }
}

export const errorClient = new ErrorClient();
